import { render, staticRenderFns } from "./deleteCommunityRecommend.vue?vue&type=template&id=21a9d9da&scoped=true"
import script from "./deleteCommunityRecommend.vue?vue&type=script&lang=js"
export * from "./deleteCommunityRecommend.vue?vue&type=script&lang=js"
import style0 from "./deleteCommunityRecommend.vue?vue&type=style&index=0&id=21a9d9da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a9d9da",
  null
  
)

export default component.exports